export default __webpack_public_path__ + "static/media/manual23.33508b5c.png";